import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'medpace-labeled-text',
    imports: [MatTooltip],
    templateUrl: './labeled-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabeledTextComponent {
    label = input<string>();
    text = input<string>();
    textLines = input<string[]>();
    tooltip = input<string>();
}
